// import { OverridedMixpanel } from "mixpanel-browser";
import { ApiConfig } from "../../config";

interface WebConfig extends ApiConfig {
    DOMAIN_URL: string
    CALLBACK_DOMAIN: string
    resources: {
        root: string
        fileTypesIcons: string
        froalaIcons: string
    }
    // mixpanel?: OverridedMixpanel
}

export const CONFIG: WebConfig = {
    DOMAIN_URL: 'http://qa.tuqqi.com',
    API_URL: 'https://api2.tuqqi.com',
    //API_URL: 'http://dev3.tuqqi.com:8080',
    //API_URL: 'http://localhost:5000',
    //API_URL: 'http://qa.tuqqi.com:8080',
    // API_URL: 'https://qa2.tuqqi.com',


    CALLBACK_DOMAIN: 'http://localhost:3000/callback',
    // CALLBACK_DOMAIN: 'https://newui.tuqqi.com',

    // mixpanel: undefined,

    resources: {
        root: '/resources',
        fileTypesIcons: '/resources/file-types',
        froalaIcons: '/resources/froala'
    }
}

export const setApiUrl = (apiUrl: string) => {
    CONFIG.API_URL = apiUrl
}

export const setRefreshFeed = (callback: () => void) => {
    CONFIG.refreshFeed = callback
}

export const setItemUpdate = (callback: (docId: string) => void) => {
    CONFIG.updateItem = callback
}

export const setDomainUrl = (domainUrl: string) => {
    CONFIG.DOMAIN_URL = domainUrl
}



// export const setMixpanel = (mixpanel: OverridedMixpanel) => {
//     CONFIG.mixpanel = mixpanel
// }

